<template>
  <Dropdown
      v-model="dropdownPortfolio"
      :options="allPortfolios"
      @change="onPortfolioSelect"
      :disabled="disabled"
      dataKey="id" optionLabel="name"
      :filter="true"
      :placeholder='$t("common.placeholders.portfolio")'
      :showClear="true" :resetFilterOnClear="true" :resetFilterOnHide="true"
      :virtualScrollerOptions="{ itemSize: 50 }"
      style="width: 30em; margin-top:.1em"
  >

    <template #value="slotProps">
      <div v-if="slotProps.value && slotProps.value.id > 0" class="p-dropdown-option" style="width: 100%; padding: 0; margin: 0">
          <div style="overflow: hidden; padding: 0 0 0 .5em"><b style="font-size: 12px;color: #c40070;">{{
              slotProps.value.contractNumber
            }}</b>
            <b v-if="slotProps.value.sftpPortfolioAnalysisExport"
               style="font-size: 12px;color: #c40070;"> - SFTP</b></div>
          <div style="height: 1.5em; overflow: hidden; padding: 0 .5em 0 .5em; max-width: 20em"><span
              class="blue">{{ slotProps.value.name }}</span></div>
      </div>
      <div v-else>{{ $t('common.placeholders.portfolio') }}</div>
    </template>

    <template #option="slotProps">
      <div class="p-dropdown-option">
        <div class="grid" style="width: 37em">
          <div class="col-9" style="line-height: 14px;">
            <div class="col-12" style="margin: 0; padding: 0; min-height: 20px">
              <b style="font-size: 13px; color: #c40070;">{{ slotProps.option.contractNumber }}</b>
              <b v-if="slotProps.option.sftpPortfolioAnalysisExport" style="font-size: 12px;color: #c40070;"> - SFTP</b>
            </div>
            <div class="col-12" style="font-size: 13px;overflow: hidden; margin: 0; padding: 0">{{
                slotProps.option.name
              }}
            </div>
          </div>
          <div class="col-3">
            <Tag style="min-width:10em; margin-top: 1em;"
                 :value="statusDescription(slotProps.option.status)"
                 :severity="severityStatus(slotProps.option.status)"></Tag>
          </div>
        </div>
      </div>
    </template>
  </Dropdown>
</template>

<script>
import PortfolioService from '@/service/PortfolioService';
import { severityStatus, statusDescription } from '@/main';

export default {
  name: 'PortfolioDropdown',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: Object,
      default: null,
    },
  },
  emits: [ 'update:modelValue' ],
  data() {
    return {
      // filteredPortfolios: [],
      dropdownPortfolio: null,
    };
  },
  created() {
    this.portfolioService = new PortfolioService();
  },
  mounted() {
    this.dropdownPortfolio = this.modelValue;
    // this.filteredPortfolios = this.allPortfolios;
  },
  computed: {
    allPortfolios() {
      return this.$store.getters['portfolioList'];
    },
  },
  watch: {
    modelValue(newValue) {
      this.dropdownPortfolio = newValue;
    },
  },
  methods: {
    severityStatus,
    statusDescription,
    onPortfolioSelect(event) {
      if (!event.value) {
        this.$emit('update:modelValue', null);
      } else
        this.portfolioService.getPortfolioById(event.value.id)
            .then(portfolio => {
              this.$emit('update:modelValue', portfolio);
            }).catch(e => {
          console.log('errore: ' + e);
          this.$toast.add({
            severity: 'error',
            summary: this.$t('common.toasts.somethingWentWrong.summary'),
            detail: this.$t('common.toasts.somethingWentWrong.detail'),
          });
          this.$store.dispatch('resetLoading');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "public/assets/sass/overrides/layout_variables";

.blue {
  color: $blue1;
}

.link-disabled {
  cursor: wait !important;
  border: none !important;
  background-color: transparent !important;
  position: relative;
  display: block;
  width: 44px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  border-radius: 50%;
}

.topbar-icon-disabled {
  color: rgba(67, 195, 191, 0.49);
  line-height: inherit;
  font-size: 24px;
}

.tag-username {
  line-height: 2em;
  font-size: 14px;
  font-weight: 400;
  padding: 0.5em;
  color: #43C3BF;
}

.list-portfolio {
  .p-dropdown-option {
    min-width: 38em !important;

    //div {
    //  line-height: 14px !important;
    //}
  }

  span {
    vertical-align: top;
    position: relative;
    //top: 0.55em;
  }

  .p-dropdown {
    //max-width: 30em;
    min-width: 40em;
    min-height: 3em;
    margin-left: 1em;
    margin-right: 1em;
  }

  line-height: 2em;
  font-size: 14px;
  font-weight: 400;
  padding: 0.5em;
  color: #43C3BF;
}

@media screen and (max-width: 1280px) {
  .list-portfolio {
    .p-dropdown {
      max-width: 30em;
    }
  }
}

.button-create-portfolio {
  margin-top: 0.65em;
  float: right;
  color: #43C3BF;
  background-color: #FFF;
  border-color: #FFF;
  border-radius: 1em;
}

.button-create-portfolio-inloading {
  margin-top: 0.65em;
  float: right;
  cursor: wait !important;
  color: #43C3BF;
  background-color: #FFF;
  border-color: #FFF;
  border-radius: 1em;
}

.topbar-button-selected {
  color: #FFF;
  background-color: #43C3BF;
  border-color: #43C3BF;
  border-radius: 1em;
}

.badge {
  position: absolute;
  line-height: 1.2em;
  height: 1.2em;
  width: 1.2em;
  font-size: 0.8em;
  color: red;
  left: 2.2em;
  top: 0.1em;
  font-weight: bold;
}
</style>
